// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2oHq9","title":"BackImages_title__32Zc-","images":"BackImages_images__3xhr5"};